<template>
  <v-card style="width: 100%">
    <div class="w-full">
      <div class="bg-white shadow overflow-hidden sm:rounded-lg w-full">
        <div class="px-4 py-5 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            O meu perfil
          </h3>
        </div>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <label class="label-modal">Nome</label>
                <v-text-field
                  disabled
                  color="#f8ac4a"
                  v-model="getSession.user.nome"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <label class="label-modal">Username</label>
                <v-text-field
                  disabled
                  color="#f8ac4a"
                  v-model="getSession.user.username"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <label class="label-modal">Email</label>
                <v-text-field
                  disabled
                  color="#f8ac4a"
                  v-model="getSession.user.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <label class="label-modal">Entidade ou Associada?</label>
                <v-autocomplete
                  disabled
                  color="#f8ac4a"
                  :items="classes"
                  v-model="getSession.user.associada"
                  item-text="nome"
                  item-value="id_classe"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md12 v-if="getSession.user.associada == 2">
                <label class="label-modal">Entidade associada?</label>
                <v-autocomplete
                  color="#f8ac4a"
                  disabled
                  :items="associadas"
                  multiple
                  v-model="getSession.user.associadas"
                  item-text="nome"
                  item-value="id_associada"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <label class="label-modal">Estado</label>
                <v-text-field
                  disabled
                  color="#f8ac4a"
                  :value="getSession.user.ativo == 1 ? 'ATIVO' : 'INATIVO'"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <label class="label-modal"
                  >Selecione o(s) setor(es) de atividade da entidade</label
                >
                <v-autocomplete
                  color="#f8ac4a"
                  :items="getSectores"
                  multiple
                  v-model="setores"
                  item-text="nome"
                  item-value="id_setor"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <label class="label-modal"
                  >Selecione a natureza jurídica da entidade</label
                >
                <v-autocomplete
                  color="#f8ac4a"
                  :items="tipos"
                  v-model="getSession.user.publico"
                  item-text="nome"
                  item-value="id_tipo"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="getSession.user.publico == 1">
                <label class="label-modal">Setor público</label>
                <v-autocomplete
                  color="#f8ac4a"
                  :items="setores_publicos"
                  v-model="getSession.user.setor_publico"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="getSession.user.publico == 2">
                <label class="label-modal">Setor não público</label>
                <v-autocomplete
                  color="#f8ac4a"
                  :items="fins_lucrativos"
                  v-model="getSession.user.fins_lucrativos"
                ></v-autocomplete>
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
                v-if="getSession.user.fins_lucrativos == 'Sem fins lucrativos'"
              >
                <label class="label-modal">Tipo</label>
                <v-autocomplete
                  color="#f8ac4a"
                  :items="tipos_fins_lucrativos"
                  v-model="getSession.user.tipo_fins_lucrativos"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-flex xs12 sm12 md12>
              <label class="label-modal"
                >A entidade trabalha formalmente em setores diretamente
                relacionados com a educação?</label
              >
              <v-autocomplete
                color="#f8ac4a"
                :items="['Sim', 'Não']"
                v-model="getSession.user.trabalha_educacao"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <label class="label-modal"
                >A entidade reconhece formalmente a Educação para o
                Desenvolvimento em documentos estratégicos e/ou
                operacionais?</label
              >
              <v-autocomplete
                color="#f8ac4a"
                :items="['Sim', 'Não']"
                v-model="getSession.user.trabalha_estrategicos"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <label class="label-modal"
                >Selecione o distrito onde a entidade desempenha uma intervenção
                mais ativa</label
              >
              <v-autocomplete
                color="#f8ac4a"
                :items="listOfDistritos"
                item-text="name"
                item-value="name"
                v-model="getSession.user.distrito"
              ></v-autocomplete>
            </v-flex>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat @click.native="submit">Guardar</v-btn>
          </v-card-actions>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { instance as axios } from "../store/axios";
import distritos from "../store/distritos.json";

export default {
  data() {
    return {
      distritos: [],
      tipos_fins_lucrativos: ["Associação", "Cooperativa", "Fundação"],
      fins_lucrativos: ["Sem fins lucrativos", "Com fins lucrativos"],
      setores_publicos: ["Central", "Local", "Regional"],
      setores: [],
      classes: [
        { id_classe: 1, nome: "Entidade signatária" },
        { id_classe: 2, nome: "Associada de entidade signatária" },
      ],
      associadas: [
        { id_associada: 1, nome: "PPONGD" },
        { id_associada: 2, nome: "ARIPESE" },
        { id_associada: 3, nome: "ANIMAR" },
      ],
      tipos: [
        { id_tipo: 1, nome: "Público" },
        { id_tipo: 2, nome: "Não Público" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getSession: "session/getState",
      getInstituicaoById: "instituicoes/getById",
      getSectores: "setores/getAll",
    }),
    instituicao() {
      return this.getInstituicaoById(this.getSession.user.id_instituicao);
    },
    listOfDistritos() {
      return [
        {
          level: 1,
          code: 0,
          name: "Nacional",
        },
        ...distritos.filter(({ level }) => level === 1),
      ];
    },
  },

  methods: {
    submit() {
      let payload = {
        instituicao: this.getSession.user,
        setores: this.setores,
        publico: this.getSession.user.publico,
        fins_lucrativos: this.getSession.user.fins_lucrativos,
        tipo_fins_lucrativos: this.getSession.user.tipo_fins_lucrativos,
        setor_publico: this.getSession.user.setor_publico,
        trabalha_educacao: this.getSession.user.trabalha_educacao,
        trabalha_estrategicos: this.getSession.user.trabalha_estrategicos,
        distrito: this.getSession.user.distrito,
      };
      this.$store.dispatch("instituicoes/updatePerfil", payload).then((res) => {
        this.toast("success", "dados alterados com sucesso!");
      });
    },

    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      }
    },
  },
  mounted() {
    this.distritos = distritos;

    let payload = {
      id_instituicao: this.getSession.user.id_instituicao,
    };
    axios.post("/user/setores/", { ...payload }).then((res) => {
      if (res.data.data == "Sem resultados") {
        this.setores = [];
      } else {
        this.setores = res.data.data;
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Perfil.vue